module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading1 || _vm.loading2),
      expression: "loading1 || loading2"
    }],
    staticClass: "index",
    attrs: {
      "element-loading-text": "拼命加载中"
    }
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("首页概览")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-today"
  }, [_c('div', {
    staticClass: "member"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('strong', [_c('em', [_vm._v(_vm._s(_vm.info.new_member_num))]), _vm._v(" 人")]), _vm._v(" "), _c('ul', [_c('li', [_vm._m(2, false, false), _vm._v(" "), _c('span', [_c('em', [_vm._v(_vm._s(_vm.info.old_member_num))]), _vm._v(" 个")])]), _vm._v(" "), _c('li', [_vm._m(3, false, false), _vm._v(" "), _c('span', [_c('em', [_vm._v(_vm._s(_vm.info.month_new_member))]), _vm._v(" 人")])]), _vm._v(" "), _c('li', [_vm._m(4, false, false), _vm._v(" "), _c('span', [_c('em', [_vm._v(_vm._s(_vm.info.total_member))]), _vm._v(" 人")])])])]), _vm._v(" "), _c('div', {
    staticClass: "fee"
  }, [_c('h3', [_vm._v("活动运营数据统计")]), _vm._v(" "), _c('strong', [_c('em', [_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.info.today_total_amt)))]), _vm._v(" " + _vm._s(_vm.role.currency))]), _vm._v(" "), _c('ul', [_c('li', [_vm._m(5, false, false), _vm._v(" "), _c('span', [_c('em', [_vm._v(_vm._s(_vm.info.nums))]), _vm._v(" 笔")])]), _vm._v(" "), _c('li', [_vm._m(6, false, false), _vm._v(" "), _c('span', [_c('em', [_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.info.today_txamt)))]), _vm._v(" " + _vm._s(_vm.role.currency))])]), _vm._v(" "), _c('li', [_vm._m(7, false, false), _vm._v(" "), _c('span', [_c('em', [_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.info.month_txamt)))]), _vm._v(" " + _vm._s(_vm.role.currency))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "data-show"
  }, [_c('h2', [_vm._v("活动运营数据统计")]), _vm._v(" "), (_vm.activitys.length > 0) ? _c('div', {
    staticClass: "content"
  }, _vm._l((_vm.activitys), function(activity) {
    return _c('div', {
      staticClass: "item"
    }, [(activity.type === 'coupon') ? _c('div', {
      on: {
        "click": function($event) {
          _vm.openDetail('coupon')
        }
      }
    }, [_vm._m(8, true, false), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_c('i', {
      staticClass: "icon"
    }), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(activity.title))]), _vm._v("\n              活动已进行" + _vm._s(activity.going_days) + "天\n            ")])]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("领取数")]), _vm._v(" "), _c('span', [_c('em', [_vm._v(_vm._s(activity.used_num))]), _vm._v("个")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("使用数")]), _vm._v(" "), _c('span', [_c('em', [_vm._v(_vm._s(activity.use))]), _vm._v("个")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("刺激消费数")]), _vm._v(" "), _c('span', [_c('em', [_vm._v(_vm._s(_vm._f("formatCurrency")(activity.total_amt)))]), _vm._v("元")])])])]) : (activity.type === 'card') ? _c('div', {
      on: {
        "click": function($event) {
          _vm.openDetail('card')
        }
      }
    }, [_vm._m(9, true, false), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_c('i', {
      staticClass: "icon collect"
    }), _vm._v(" "), _c('span', [_c('strong', [_vm._v("满" + _vm._s(activity.exchange_pt) + "点送" + _vm._s(activity.goods_name))]), _vm._v("\n              活动已进行" + _vm._s(activity.going_days) + "天\n            ")])]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("参与人数")]), _vm._v(" "), _c('span', [_c('em', [_vm._v(_vm._s(activity.in_person_no))]), _vm._v("个")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("会员复购数")]), _vm._v(" "), _c('span', [_c('em', [_vm._v(_vm._s(activity.repeat_no))]), _vm._v("个")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("兑换数")]), _vm._v(" "), _c('span', [_c('em', [_vm._v(_vm._s(activity.exchange_num))]), _vm._v("份")])])])]) : _vm._e(), _vm._v(" "), (activity.type === 'prepaid') ? _c('div', {
      on: {
        "click": function($event) {
          _vm.openDetail('storage')
        }
      }
    }, [_vm._m(10, true, false), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_c('i', {
      staticClass: "icon store"
    }), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(activity.title))]), _vm._v("\n              活动已进行" + _vm._s(activity.going_days) + "天\n            ")])]), _vm._v(" "), _c('ul', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('li', [_c('strong', [_vm._v("储值会员")]), _vm._v(" "), _c('span', [_c('em', [_vm._v(_vm._s(activity.user_num))]), _vm._v("位")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("储值金额")]), _vm._v(" "), _c('span', [_c('em', [_vm._v(_vm._s(_vm._f("formatCurrency")(activity.total_pay_amt)))]), _vm._v("元")])])])]) : _vm._e()])
  })) : _c('div', {
    staticClass: "no-content"
  }, [_vm._v("暂无活动")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('h2', {
    staticClass: "panel-header__desc"
  }, [_vm._v("会员及交易数据统计")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('i'), _vm._v("今日会员新增")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i'), _vm._v("今日回头客")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i'), _vm._v("本月会员新增")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i'), _vm._v("累计会员数")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i'), _vm._v("今日交易笔数")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i'), _vm._v("今日实收")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i'), _vm._v("本月实收")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('i'), _vm._v("进行中的活动：红包")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('i', {
    staticClass: "collect"
  }), _vm._v("进行中的活动：集点")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('i', {
    staticClass: "store"
  }), _vm._v("进行中的活动：储值")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf8ae9de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/index.vue
// module id = 835
// module chunks = 1